/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-03-23 18:30:48
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-06-19 15:13:55
 * @FilePath: \xm-runing-main\src\components\Application\hooks\useAccountInfo.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import logoUrl from "@/assets/images/header.jpg";
import {CurrentUtils, getSystemConfigProp, QueryCommand} from "xmgoing-server";
import SysConfigUtils from "@/utils/sysConfigUtils";
import {dbUtils, StorageUtils} from 'xmgoing-utils';
import {initDomainIcon, initPageLogoByBusId, initPageTitle} from "@/utils/CurSystemConfigUtils";
import {useGlobSetting} from "@/hooks/setting";

const systemName = ref('');
const fontSizeTitle = ref(16);
const logoUrlObj: any = ref(logoUrl);
const logoHeightVal = ref(48);
const logoWidthVal = ref(240);
const loadingLogoFlag = ref(false);
let accountInfoInitialized = false;
let loadingAccountInfo = false;
let tenantLogoLocked = false;

export function clearAccountInfoCache() {
  StorageUtils.removeSessionItem('curAccountInfo');
  tenantLogoLocked = false;
}

function isCurAccountInfoValid(accountInfoConfig: Record<string, any>) {
  const currentUserId = StorageUtils.getSessionItem('userId');
  if (currentUserId) {
    const cachedUserId = accountInfoConfig.userId || accountInfoConfig.id;
    if (cachedUserId && String(cachedUserId) !== String(currentUserId)) {
      return false;
    }
  }
  const userInfo = dbUtils.getCachUser();
  if (userInfo?.tenantId && accountInfoConfig.tenantId
    && String(userInfo.tenantId) !== String(accountInfoConfig.tenantId)) {
    return false;
  }
  return true;
}

function buildTenantLogoUrl(logoImgUrl: string) {
  // 如果已经是完整 URL（以 http:// 或 https:// 开头），直接返回
  if (logoImgUrl.startsWith('http://') || logoImgUrl.startsWith('https://')) {
    return logoImgUrl;
  }
  // 否则拼接完整路径
  return `${SysConfigUtils.go_eplat_adress}/api/pe-attachment/attachment/showImg/${logoImgUrl}`;
}

/**
 * 获取系统标题信息
 */
function getSystemTitle(systemName, fontSizeTitle): string {
  const projectI18n = StorageUtils.getSessionItem("projectI18n") === "en-US" ? "en-US" : "zh-CN";
  if (CurrentUtils.getUserFlag()) {
    //如果是普通用户
    if (projectI18n === 'en-US') {
      systemName.value = getSystemConfigProp('systemTitleEn');
    } else {
      systemName.value = getSystemConfigProp('systemTitle');
    }
    fontSizeTitle.value = getSystemConfigProp('systemFontSize');
  }
  if (CurrentUtils.getGroupAdminFlag() || CurrentUtils.getSystemAdminFlag()) {
    if (projectI18n === 'en-US') {
      //如果是集团管理员
      systemName.value = getSystemConfigProp('groupSystemTitleEn');
    } else {
      systemName.value = getSystemConfigProp('groupSystemTitle');
    }
    fontSizeTitle.value = getSystemConfigProp('groupSystemFontSize');
  }
  if (CurrentUtils.getUnitAdminFlag()) {
    CurrentUtils.loadCurrentAccount(false, (res) => {
      //如果是代理
      if (res.unitType === 'merchant') {
        if (projectI18n === 'en-US') {
          systemName.value = getSystemConfigProp('daiLiSystemTitleEn');
        } else {
          systemName.value = getSystemConfigProp('daiLiSystemTitle');
        }
        fontSizeTitle.value = getSystemConfigProp('daiLiSystemFontSize');
      } else {
        //如果是普通公司
        if (projectI18n === 'en-US') {
          systemName.value = getSystemConfigProp('gongSiSystemTitleEn');
        } else {
          systemName.value = getSystemConfigProp('gongSiSystemTitle');
        }
        fontSizeTitle.value = getSystemConfigProp('gongSiSystemFontSize');
      }
    })
  }
}


/**
 * 加载系统配置信息
 * @param loadCurSystemConfig
 */
const initDomainMapInfo = function (loadCurSystemConfig) {
  const {websiteDomain, websiteDomainIcon, websiteDomainLogo} = loadCurSystemConfig;
  //如果存在域名映射
  if (websiteDomain) {
    //初始化系统的icon
    initDomainIcon({websiteDomain, websiteDomainIcon});
    //如果存在域名logo
    if (websiteDomainLogo) {
      //初始化系统的logo
      initPageLogoByBusId({websiteDomain, websiteDomainLogo}, (fileUrl) => {
        if (fileUrl && !tenantLogoLocked) {
          logoUrlObj.value = fileUrl;
          StorageUtils.addItem("domainLoginUrl", fileUrl)
        }
        loadingLogoFlag.value = false;
      })
    } else {
      loadingLogoFlag.value = false;
    }
  } else {
    loadingLogoFlag.value = false;
  }
}
function initSystemNameByGroup() {
  tenantLogoLocked = false;
  try {
    const data = StorageUtils.getItem("loadCurSystemConfig");
    const {systemLogo, logoHeight, logoWidth} = JSON.parse(data);
    logoHeightVal.value = logoHeight;
    logoWidthVal.value = logoWidth;
    getSystemTitle(systemName, fontSizeTitle);
    useGlobSetting({systemName});
    initPageTitle(JSON.parse(data));
    logoUrlObj.value = StorageUtils.getItem("domainLoginUrl") || systemLogo;
    initDomainMapInfo(JSON.parse(data));
    return;
  } catch (e) {

  }
}

const initInfoByAccountConfig = function ({
                                            accountInfoConfig,
                                          }: any) {
  const {enName, logoImgUrl, tenantId} = accountInfoConfig;
  //如果是groupAdmin
  if ((tenantId + '') === '000000') {
    initSystemNameByGroup();
    return;
  }
  tenantLogoLocked = false;
  //如果租户自己定义了 则采用租户定义
  if (enName) {
    systemName.value = enName;
  } else {
    //如果租户没有定义则采用全局定义
    initSystemNameByGroup();
  }
  if (logoImgUrl) {
    tenantLogoLocked = true;
    logoUrlObj.value = buildTenantLogoUrl(logoImgUrl);
  }
}

//加载租户信息
function loadAccountInfo() {
  if (loadingAccountInfo) {
    return;
  }
  const curAccountInfoStr = StorageUtils.getSessionItem("curAccountInfo");
  if (curAccountInfoStr) {
    try {
      const accountInfoConfig = JSON.parse(curAccountInfoStr);
      if (isCurAccountInfoValid(accountInfoConfig)) {
        initInfoByAccountConfig({accountInfoConfig});
        return;
      }
      clearAccountInfoCache();
    } catch (e) {
      clearAccountInfoCache();
    }
  }
  loadingAccountInfo = true;
  const queryCommand = new QueryCommand({
    url: '/api/pe-portal/account/getCurAccountInfo',
    showTip: false,
  });
  queryCommand.executeQuery({
    page: false, params: {}, successFun: (res) => {
      loadingAccountInfo = false;
      StorageUtils.addSessionItem("curAccountInfo", JSON.stringify(res));
      initInfoByAccountConfig({accountInfoConfig: res});
    },
    errorFun: () => {
      loadingAccountInfo = false;
    }
  })
}

export function useAccountInfo() {
  if (!accountInfoInitialized) {
    accountInfoInitialized = true;
    loadAccountInfo();
  }

  return {
    loadingLogoFlag,
    fontSizeTitle,
    logoWidthVal,
    logoHeightVal,
    systemName,
    logoUrlObj
  }
}
